export default {
  title: "Close Corrected Issue",
  content: "This cannot be undone!",
  label: "Closing comment",
}
